import type { ReactNode } from 'react';

const PACKAGE_SUFFIX_REGEX = /\bpackages?\b\s*$/i;

export const formatPackLabel = (name: string): string =>
  PACKAGE_SUFFIX_REGEX.test(name) ? name : `${name} package`;

export const formatPackList = (names: string[]): ReactNode => {
  if (names.length === 0) {
    return null;
  }

  if (names.length === 1) {
    return <b>{formatPackLabel(names[0])}</b>;
  }

  return (
    <>
      {names.map((name, index) => (
        <span key={`${name}-${index}`}>
          {index > 0 && (index === names.length - 1 ? ' and ' : ', ')}
          <b>{formatPackLabel(name)}</b>
        </span>
      ))}
    </>
  );
};
